import { useEffect, useState } from "react"
import { Button, Modal, ProgressBar, Table } from "react-bootstrap"
import NumberFormat from "react-number-format"
import { useDispatch, useSelector } from "react-redux"
import { getAccessToken } from "../../store/auth/selector"
import { rewardFriends, rewardHistories, rewardInfo, rewardLoading, rewardHistoriesInfo } from "../../store/secure/selector"

import * as secureActions from "../../store/secure/actions";
import { getAppInfo, getGateConf } from "../../store/app/selector"
import { useTranslation, Trans } from "react-i18next"

import { ArrowLeftCircle } from 'react-bootstrap-icons';
import "./style.scss"
import { useInterval } from "../../hooks/useInterval"
const Reward = () => {
    const [show, setShow] = useState(true)
    const [historyShow, setShowHistory] = useState(false);
    const [ruleShow, setShowRule] = useState(false);
    const [remaining, setRemaining] = useState(0)
    const [reset_day, setResetDay] = useState(0)
    const [reset_hour, setResetHour] = useState(0)
    const [reset_min, setResetMin] = useState(0)
    const [reset_second, setResetSec] = useState(0)

    const [estReward, setEstReward] = useState(0)
    const [estPesos, setEstPesos] = useState(0)

    const dispath = useDispatch()
    const appInfo = useSelector(state => getAppInfo(state))

    const access_token = useSelector(state => getAccessToken(state, appInfo))
    const isLoading = useSelector(state => rewardLoading(state));

    const gateConf = useSelector(state => getGateConf(state))


    const rewardInfoData = useSelector(state => rewardInfo(state))
    const rewardFriendsList = useSelector(state => rewardFriends(state))
    const rewardHistoryList = useSelector(state => rewardHistories(state))
    const rewardHistoryInfo = useSelector(state => rewardHistoriesInfo(state))

    useEffect(() => {
        dispath(secureActions.getRewardInfo(access_token, gateConf.apiUrl))
        dispath(secureActions.getRewardFriends(access_token, gateConf.apiUrl))

    }, [appInfo])

    useEffect(() => {
        if (rewardInfoData !== undefined) {
            setRemaining(rewardInfoData.timestamp)
        }
    }, [rewardInfoData])

    useEffect(() => {
        if (rewardFriendsList != undefined) {
            let reward = 0
            rewardFriendsList.map((item, index) => {
                reward = reward + item.estReward;
            })

            setEstReward(reward)
            setEstPesos(reward / 20000)
        }

    }, [rewardFriendsList])

    useInterval(() => {
        if (remaining <= 0) {
            setRemaining(7 * 24 * 60 * 60)
        }
        setRemaining(remaining - 1)

        setResetDay(Math.floor(remaining / 60 / 60 / 24))
        setResetHour(Math.floor((remaining - reset_day * 60 * 60 * 24) / 60 / 60))
        setResetMin(Math.floor((remaining - reset_day * 60 * 60 * 24 - reset_hour * 60 * 60) / 60))
        setResetSec(remaining - reset_day * 60 * 60 * 24 - reset_hour * 60 * 60 - reset_min * 60)

    }, 1000)

    const { t } = useTranslation('translations');


    const handleShowHistory = () => {
        dispath(secureActions.getRewardHistory(access_token, gateConf.apiUrl))
        dispath(secureActions.getRewardHistoryInfo(access_token, gateConf.apiUrl))
        setShowHistory(true)
        setShow(false)
    }

    const handleShowRule = () => {
        setShow(false)
        setShowRule(true)
    }

    const handleBack = () => {
        setShow(true)
        setShowRule(false)
        setShowHistory(false)
    }
    return (
        <div id="reward">
            {isLoading && <div className="loading"></div>}
            {ruleShow && <div className="rule">
                <div className="head">
                    <span className="back" onClick={() => handleBack()}><ArrowLeftCircle /></span> {t('txt53')}
                </div>
                <div dangerouslySetInnerHTML={{ __html: t('txt67') }} />
            </div>}


            {historyShow && <div className="history">
                <div className="head">
                    <span className="back" onClick={() => handleBack()}><ArrowLeftCircle /></span> {t('txt7')}
                </div>
                <div className="historiesList">
                    {rewardHistoryList && <>
                        {
                            rewardHistoryInfo && <div className="info">
                                <div className="friends"><Trans
                                    i18nKey={'txt52'}
                                    ns="translations"
                                    components={{
                                        chip: <NumberFormat
                                            value={rewardHistoryInfo.friends}
                                            thousandSeparator={true}
                                            displayType={'text'}
                                        />
                                    }}
                                /></div>
                                <div className="reward">
                                    <Trans
                                        i18nKey={'txt60'}
                                        ns="translations"
                                        components={{
                                            chip: <NumberFormat
                                                value={rewardHistoryInfo.reward}
                                                thousandSeparator={true}
                                                suffix={rewardHistoryInfo.reward > 0 ? " chips" : " chip"}
                                                displayType={'text'}
                                            />,
                                            peso: <NumberFormat
                                                value={rewardHistoryInfo.reward / 20000}
                                                thousandSeparator={true}
                                                prefix="~"
                                                suffix={rewardHistoryInfo.reward > 0 ? " Pesos" : " Peso"}
                                                displayType={'text'}
                                            />
                                        }}
                                    />
                                </div>
                            </div>
                        }
                        <Table responsive >
                            <thead>
                                <tr>
                                    <th>{t("txt61")}</th>
                                    <th>{t("txt62")}</th>
                                    <th>{t("txt63")}</th>
                                    <th>{t("txt64")}</th>
                                    <th>{t("txt65")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {rewardHistoryList.map((item, index) => {
                                    return (
                                        <tr key={item + index}>
                                            <td>{item.userid}</td>
                                            <td><NumberFormat
                                                value={item.thisWeek}
                                                thousandSeparator={true}
                                                displayType={'text'}
                                            /></td>
                                            <td><NumberFormat
                                                value={item.lastWeek}
                                                thousandSeparator={true}
                                                displayType={'text'}
                                            /></td>
                                            <td><NumberFormat
                                                value={item.thisMonth}
                                                thousandSeparator={true}
                                                displayType={'text'}
                                            /></td>
                                            <td><NumberFormat
                                                value={item.lastMonth}
                                                thousandSeparator={true}
                                                displayType={'text'}
                                            /></td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </Table>
                    </>
                    }
                </div>
            </div>}

            {show && <>
                {rewardInfoData && <div className="information">
                    <div className="statistics">
                        <div className="left">
                            <p className="title">{t('txt47')}</p>
                            <p>
                                <Trans
                                    i18nKey={'txt48'}
                                    ns="translations"
                                    components={{
                                        chip: <NumberFormat
                                            displayType={'text'}
                                            value={rewardInfoData.chip}
                                            thousandSeparator={true}
                                        />
                                    }}
                                />
                            </p>
                            <p>
                                <Trans
                                    i18nKey={'txt49'}
                                    ns="translations"
                                    components={{
                                        percent: <NumberFormat
                                            value={rewardInfoData.percent}
                                            thousandSeparator={true}
                                            suffix={"%"}
                                            prefix="lv."
                                            displayType={'text'}
                                        />
                                    }}
                                />
                            </p>
                        </div>
                        <div className="right">
                            <Trans
                                i18nKey={'txt50'}
                                ns="translations"
                                components={{
                                    day: <NumberFormat
                                        displayType={'text'}
                                        value={reset_day}
                                        suffix="d"
                                        prefix={reset_day < 10 ? "0" : ""}
                                        thousandSeparator={true}
                                    />,
                                    hour: <NumberFormat
                                        displayType={'text'}
                                        value={reset_hour}
                                        suffix="h"
                                        prefix={reset_hour < 10 ? "0" : ""}
                                        thousandSeparator={true}
                                    />,
                                    minute: <NumberFormat
                                        displayType={'text'}
                                        value={reset_min}
                                        suffix="m"
                                        prefix={reset_min < 10 ? "0" : ""}
                                        thousandSeparator={true}
                                    />
                                }}
                            />
                        </div>
                    </div>

                    <div className="bar">
                        <div className="percent-bar">
                            {
                                rewardInfoData.rates.map((item, index) => {
                                    return <div key={item + index} className="milestone">{item.percent}%</div>
                                })
                            }
                        </div>

                        <ProgressBar label={<NumberFormat
                            value={rewardInfoData.chip}
                            suffix={' M'}
                            thousandSeparator={true}
                            displayType={'text'}
                        />} now={rewardInfoData.progress} />
                        <div className="chip-bar">
                            {
                                rewardInfoData.rates.map((item, index) => {
                                    return <div key={item + index} className="milestone"><NumberFormat
                                        value={item.chip}
                                        thousandSeparator={true}
                                        suffix={"M"}
                                        displayType={'text'}
                                    /></div>
                                })
                            }
                        </div>
                    </div>

                    <div className="chip-estimate"><Trans
                        i18nKey={'txt51'}
                        ns="translations"
                        components={{
                            chip: <NumberFormat
                                value={estReward}
                                thousandSeparator={true}
                                suffix={estReward > 0 ? " chips" : " chip"}
                                displayType={'text'}
                            />,
                            peso: <NumberFormat
                                value={estPesos}
                                thousandSeparator={true}
                                prefix="~"
                                suffix={estPesos > 0 ? " Pesos" : " Peso"}
                                displayType={'text'}
                            />
                        }}
                    /></div>
                </div>}


                <div className="friendsList">
                    {rewardFriendsList && <><div className="head">
                        <div className="info">
                            <div className="left"><Trans
                                i18nKey={'txt52'}
                                ns="translations"
                                components={{
                                    chip: <NumberFormat
                                        value={rewardFriendsList.length}
                                        thousandSeparator={true}
                                        displayType={'text'}
                                    />
                                }}
                            /></div>
                            <div className="right">
                                <Button variant="link" onClick={handleShowHistory}>{t('txt7')}</Button>
                                <Button variant="link" onClick={handleShowRule}>{t('txt53')}</Button>
                            </div>

                        </div>
                    </div>
                        <Table responsive >
                            <thead>
                                <tr>
                                    <th>{t("txt54")}</th>
                                    <th>{t("txt55")}</th>
                                    <th>{t("txt56")}</th>
                                    <th>{t("txt57")}</th>
                                    <th>{t("txt58")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {rewardFriendsList.map((item, index) => {
                                    return (
                                        <tr key={item + index}>
                                            <td>{item.id}</td>
                                            <td>{item.username}</td>
                                            <td><NumberFormat
                                                value={item.totalChipWin}
                                                thousandSeparator={true}
                                                displayType={'text'}
                                            /></td>
                                            <td>{item.lastLogin}</td>
                                            <td><NumberFormat
                                                value={item.estReward}
                                                thousandSeparator={true}
                                                displayType={'text'}
                                            /></td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </Table>
                    </>
                    }
                </div>
            </>}

        </div>
    )
}

export default Reward